package org.teddapp.project.portfolio

import org.teddapp.project.ui.TeddTier

/**
 * Niveau d'auto-évaluation d'un critère du recueil, aligné sur les paliers du noyau :
 * même échelle à quatre marches, mêmes couleurs, mais posé à la main et non mesuré
 * en heures. Stocké tel quel (0..3) dans `competence_criterion.level`.
 */
enum class CompetenceLevel(val value: Int, val label: String, val short: String, val tier: TeddTier) {
    NonAcquis(0, "Non acquis", "—", TeddTier.Beginner),
    Notions(1, "Notions", "Notions", TeddTier.Bronze),
    Autonome(2, "Autonome", "Autonome", TeddTier.Silver),
    Maitrise(3, "Maîtrise", "Maîtrise", TeddTier.Gold);

    companion object {
        fun of(value: Long?): CompetenceLevel = of(value?.toInt())
        fun of(value: Int?): CompetenceLevel = entries.firstOrNull { it.value == value } ?: NonAcquis
    }
}

/**
 * Niveau d'une compétence = plancher de la moyenne de ses critères ; null sans critère.
 * Choix acté le 2026-09-26 (l'alternative `min`, plus sévère, n'est pas retenue en V1).
 */
fun aggregateLevel(levels: List<Long>): CompetenceLevel? {
    if (levels.isEmpty()) return null
    val mean = levels.sum().toDouble() / levels.size
    return CompetenceLevel.of(mean.toInt().coerceIn(0, 3))
}

/** Nombre de critères par niveau, indexé par [CompetenceLevel.value]. */
fun levelDistribution(levels: List<Long>): IntArray {
    val out = IntArray(4)
    levels.forEach { out[CompetenceLevel.of(it).value]++ }
    return out
}
